let isOpen = false
const windowWidth = window.innerWidth
const wrap = document.querySelector('.wrap')
const burgers = document.querySelectorAll('.burger')
const menuItems = document.querySelectorAll('.offcanvas__list-item.has-submenu')

const closeOffcanvas = () => {
  burgers.forEach(burger => {
    document.getElementById(burger.dataset.name).classList.remove('is-active')
  })

  wrap.classList.remove('menu-opened')
  isOpen = false
}

const closeOffcanvasSubmenus = () => {
  menuItems.forEach(item => {
    let submenu = item.querySelector('.offcanvas__submenu')

    item.classList.remove('is-open')
    submenu.classList.remove('is-open')
    submenu.style.height = 0
  })
}

if (burgers) {
  burgers.forEach(burger => {
    burger.addEventListener('click', e => {
      e.preventDefault()
      if (burger.classList.contains('burger--close')) {
        closeOffcanvas()
        closeOffcanvasSubmenus()
        return
      }
      document.getElementById(burger.dataset.name).classList.add('is-active')
      wrap.classList.add('menu-opened')
      isOpen = true
    })
  })

  menuItems.forEach(item => {
    let itemLink = item.querySelector('.offcanvas__list-link')
    let submenu = item.querySelector('.offcanvas__submenu')
    let submenuListHeight = item.querySelector('.offcanvas__sublist').scrollHeight

    itemLink.addEventListener('click', e => {
      e.preventDefault()

      if (item.classList.contains('is-open')) {
        item.classList.remove('is-open')
        submenu.classList.remove('is-open')
        submenu.style.height = 0
        return
      }

      item.classList.add('is-open')
      submenu.classList.add('is-open')
      submenu.style.height = `${submenuListHeight}px`
    })
  })

  wrap.addEventListener('click', e => {
    if (isOpen && !e.target.classList.contains('burger')) {
      closeOffcanvas()
      closeOffcanvasSubmenus()
    }
  })

  window.addEventListener('resize', function() {
    if (this.innerWidth != windowWidth) {
      closeOffcanvas()
      closeOffcanvasSubmenus()
    }
  })
}
